import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as PenIcon } from "../../images/penIcon.svg"
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import React, { useState } from "react";

const CommonTable = ({
  headers,
  values,
  edittable,
  tableData,
  setTableData,
}) => {
  const [edittableRow, setEdittableRow] = useState(null);
  const [edittedData, setEdittedData] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEdittedData({ ...edittedData, [name]: value });
  };

  const handleEditClick = (index) => {
    setEdittableRow(index);
    setEdittedData(tableData[index]);
  };

  const handleSaveClick = (index) => {
    setTableData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = edittedData;
      return updatedData;
    });
    setEdittableRow(null);
  };

  const handleCancelClick = () => {
    setEdittableRow(null);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: 360,
        overflowX: "auto",
        overflowY: "auto",
        border: "1px solid #C6C6C6",
      }}
    >
      <Table stickyHeader sx={{ minWidth: 900 }}>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
                key={`head${index}`}
                sx={{
                  padding: "4px 20px",
                  border: "1px solid #C6C6C6",
                  backgroundColor: "#0094FB",
                  fontWeight: 500,
                  fontSize: 14,
                  position: "sticky",
                  top: 0,
                  left: index === 0 ? 0 : "auto",
                  zIndex: index === 0 ? 4 : 3,
                  whiteSpace: "nowrap",
                  color: "#fff",
                }}
              >
                {header}
              </TableCell>
            ))}
            {edittable && (
              <TableCell
                sx={{
                  padding: "4px 20px",
                  border: "1px solid #C6C6C6",
                  backgroundColor: "#0094FB",
                  whiteSpace: "nowrap",
                }}
              />
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {values.map((row, rowIndex) => {
            const rowColor = rowIndex % 2 === 0 ? "#ffffff" : "#e3f2fd"; // alternate background
            return (
              <TableRow key={`row${rowIndex}`} hover>
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={`${headers[cellIndex]}-${rowIndex}`}
                    sx={{
                      padding: "4px 20px",
                      border: "1px solid #C6C6C6",
                      position: cellIndex === 0 ? "sticky" : "static",
                      left: cellIndex === 0 ? 0 : "auto",
                      zIndex: cellIndex === 0 ? 1 : "auto",
                      minWidth: 180,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      backgroundColor: rowColor, // apply alternate color
                    }}
                  >
                    {rowIndex === edittableRow ? (
                      <TextField
                        name={headers[cellIndex]}
                        value={edittedData[headers[cellIndex]]}
                        onChange={handleInputChange}
                        multiline
                        fullWidth
                        minRows={1}
                        maxRows={3}
                        sx={{
                          fontSize: 15,
                          "& .MuiInputBase-root": {
                            padding: "4px 8px",
                            fontSize: 14,
                          },
                        }}
                      />
                    ) : (
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 13,
                          fontWeight: 500,
                          color: "#000",
                          whiteSpace: "normal",
                          lineHeight: 1.4,
                        }}
                      >
                        {typeof cell === "string" && cell.includes("\n") ? (
                          <ol style={{ margin: 0, paddingLeft: "20px" }}>
                            {cell.split("\n").map((point, idx) => (
                              <li key={idx}>{point}</li>
                            ))}
                          </ol>
                        ) : (
                          cell
                        )}
                      </Typography>
                    )}
                  </TableCell>
                ))}
                {edittable && (
                  <TableCell
                    sx={{
                      padding: "4px 20px",
                      border: "1px solid #C6C6C6",
                      backgroundColor: rowColor,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {edittableRow === rowIndex ? (
                      <Box>
                        <IconButton
                          color="success"
                          onClick={() => handleSaveClick(rowIndex)}
                        >
                          <CheckIcon />
                        </IconButton>
                        <IconButton color="error" onClick={handleCancelClick}>
                          <CancelIcon />
                        </IconButton>
                      </Box>
                    ) : (
                      <IconButton onClick={() => handleEditClick(rowIndex)}>
                        <PenIcon style={{ width: 18, height: 18 }} />
                      </IconButton>
                    )}
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CommonTable;
